import { useEffect, useState } from "react";
import axios from "axios";
import { Spin } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
//import { refreshAccessToken } from "../repository/refreshAccessToken";
import { BASE_URL } from "../config/Config";

const AuthWrapper = ({ children }) => {
  const [authChecked, setAuthChecked] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const fetchUserGroups = async (auth) => {
    if (!auth?.access_token || !auth?.org) {
      console.error("Auth token or org missing:", auth);
      return;
    }

    try {
      const response = await axios.get(
        `${BASE_URL}/api/datasets/?org=${auth.org}`,
        {
          headers: {
            Authorization: `Bearer ${auth.access_token}`,
          },
        }
      );
      localStorage.setItem("datasets", JSON.stringify(response.data));
      // if (response.data.groups.includes("proaccounting")) {
      // } else {
      //   window.location.href = `https://proerp.defconinnovations.com/dashboard`;
      // }
    } catch (err) {
      console.error("Failed to fetch user groups:", err);
    }
  };

  useEffect(() => {
    const authData = localStorage.getItem("auth");
    if (!authData) {
      navigate("/login");
    }
    const checkAuth = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/api/check_auth/`, {
          withCredentials: true,
        });

        const data = response.data;

        if (response.status === 200 && data.is_authenticated) {
          //check permission here
          await fetchUserGroups(data);
          localStorage.setItem("auth", JSON.stringify(data));

          setIsAuthenticated(true);
        } else {
          // Not authenticated
          // window.location.href = `${BASE_URL}?next=https://ai.defconinnovations.com/`;
          window.location.href = `/login`;
          console.log("not authorized");
        }
      } catch (error) {
        setAuthChecked(true);

        if (process.env.REACT_APP_SANDBOX === "true") {
          localStorage.setItem(
            "auth",
            JSON.stringify({
              is_authenticated: true,
              username: "adeebatest",
              full_name: "",
              access: process.env.REACT_APP_access_token,
              refresh: process.env.REACT_APP_refresh_token,
              org: 1,
              userid: 5,
               "user": {
        "id": 2,
        "username": "test@gmail.com",
        "email": "test@gmail.com",
        "is_active": true
    },
            })
          );

          const data = JSON.parse(localStorage.getItem("auth"));
          await fetchUserGroups(data);

          setIsAuthenticated(true);
        } else {
          window.location.href = `/login`;
            // window.location.href = `${BASE_URL}?next=https://ai.defconinnovations.com/`;
          console.log("error sandbox false");
        }
      } finally {
        setAuthChecked(true);
      }
    };

    checkAuth();
  }, [navigate, location.pathname]);

  if (!authChecked) {
    return (
      <div className="flex items-center justify-center h-screen bg-white">
        <Spin size="large" />
      </div>
    );
  }

  return isAuthenticated ? children : null;
};

export default AuthWrapper;
